export default __webpack_public_path__ + "static/media/logo.a0e43e7e.png";